// eslint-disable-next-line import/prefer-default-export
export const REGISTRY_AWARDS_SLUG = 'registry-awards';
